var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:[
    { 'nav-open': _vm.$sidebar.showSidebar },
    { rtl: _vm.$route.meta.rtlActive }
  ]},[_c('notifications'),_c('side-bar',{attrs:{"active-color":_vm.sidebarBackground,"data-background-color":_vm.sidebarBackgroundColor}},[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: 'Dashboard',
          icon: 'dashboard',
          path: '/dashboard',
          isActive: true
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Screens',
          icon: 'desktop_windows',
          path: '/kiosks',
          isActive: true
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Flavors',
          path: '/flavors',
          isActive: true,
          icon: 'eco'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Locations',
          icon: 'place',
          path: '/locations',
          isActive: true
        }}}),_c('sidebar-item',{attrs:{"link":{ name: 'Settings', icon: 'settings', isActive: true }}},[_c('sidebar-item',{attrs:{"link":{ name: 'Users', path: '/register', isActive: true }}})],1)],1)],2),_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }